// src/components/Login.js
import React, { useState } from "react";
import './Login.scss'
import { useNavigate, Link } from "react-router-dom";
import { URL } from "../../constants/url";
import { ButtonLoading } from "../../components/loading/Loading";

const Login = ({ setAuth }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [isLoading,setIsLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    try {
      const response = await fetch(`${URL}/api/admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email, password: password }),
      });

      const data = await response.json();

      if (response.ok) {
        setAuth(true);
        navigate("/dashboard");
        setIsLoading(false)
      } else {
        setError(data.message || "Invalid credentials");
        setIsLoading(false)
        setTimeout(() => {
          setError("")
        },1000)
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
      setIsLoading(false)
    }
  };

  return (
    <div className="login-container" >
    <form onSubmit={handleSubmit} className="form-login">
      <h3>Login Here</h3>
      <div>
        <label htmlFor="email" className="style-lable-login">Email</label>
        <input
        className="style-input-login"
          type="text"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div>
        <label htmlFor="password" className="style-lable-login">Password</label>
        <input
        className="style-input-login"
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button type="submit" className="button-login">{isLoading === true ? <ButtonLoading/> : "Log In"}</button>
    </form>
    <Link to= "/"></Link>
  </div>

  );
};

export default Login;
